import { map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MGISConstants } from '../constants/mgis.constants';
import { environment } from '../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private loggedIn = false;
    private authData: any;

    constructor(
        private _http: HttpClient,
        private _mgisConstants: MGISConstants,
    ) {

    }

    get currentAuthData(): any {
        return this.authData;
    }

    login(username: string, password: string): Observable<boolean> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');

        let tokenUrl = `${environment.apiUrl}token`;
        let passwordEncoded = encodeURIComponent(password);
        let body = `username=${username}&password=${passwordEncoded}&grant_type=password&scope=openid email roles&grantType=password`;
        return this._http.post(tokenUrl, body, { headers }).pipe(
            map(response => {
                this.authData = response;
                localStorage.setItem('accessToken', this.authData[this._mgisConstants.AuthKeys.AccessTokenKey]);
                if (this.authData) {
                    this.loggedIn = true;
                } else {
                    this.loggedIn = false;
                }
                return this.loggedIn;
            }));
    }

    getToken(): string {
        if (!this.authData) {
            return localStorage.getItem('accessToken') || '';
        }
        return this.authData[this._mgisConstants.AuthKeys.AccessTokenKey];
    }
}